export default __webpack_public_path__ + "static/media/visa.8d445a51.png";